import { connect } from 'react-redux';

import { PrevNextPagination } from 'src/components/pagination';
import { SCROLL_TO_TOP_DURATION } from 'src/constants/permalink-scroll';
import scrollTo from 'src/redux/global/actions/scroll-to';

// @ts-ignore TODO: fix noImplicitAny error here
function mapDispatchToProps(dispatch) {
  return {
    onPageChange: () =>
      dispatch(
        scrollTo({
          targetId: 'root',
          duration: SCROLL_TO_TOP_DURATION,
        })
      ),
  };
}

export default connect(null, mapDispatchToProps)(PrevNextPagination);
